import React from "react";
import { useTranslation } from "react-i18next";

export default function DeviceCompatibilityNotice({
  className = "",
  titleClassName = "title-text",
}) {
  const { t } = useTranslation();

  return (
    <div
      className={["flex flex-col gap-4 text-left", className]
        .filter(Boolean)
        .join(" ")}
    >
      <h1 className={titleClassName}>
        {t(
          "deviceCompatibility.title",
          "This device or browser is not ready for recording",
        )}
      </h1>

      <p>
        {t(
          "deviceCompatibility.intro",
          "We couldn't confirm that this device meets the recording requirements yet.",
        )}
      </p>

      <ul className="guide-list">
        <li>
          {t(
            "deviceCompatibility.tipBrowser",
            "Use a supported browser such as Chrome, Edge, or Safari.",
          )}
        </li>
        <li>
          {t(
            "deviceCompatibility.tipInApp",
            "If you opened this link inside another app, open it in your phone's browser instead.",
          )}
        </li>
        <li>
          {t(
            "deviceCompatibility.tipUpdate",
            "Make sure your browser and operating system are up to date, then try again.",
          )}
        </li>
      </ul>

      <p className="muted-text">
        {t(
          "deviceCompatibility.help",
          "You can return to the recording flow after switching browser or updating your device.",
        )}
      </p>
    </div>
  );
}
